/**
 * Overtime Export Service
 * 
 * Handles export of HHEE (overtime) summaries to Excel format
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type {
  LC_ExportEmployeeHheeSummaryIn,
} from './overtimeReport.types';


export class OvertimeExportService {
  /**
   * Export employee HHEE summary to Excel
   * 
   * @param input - Export parameters (monthlyCutId, type, format)
   * @returns Promise with Blob containing the Excel file
   */
  exportEmployeeHheeSummary(
    input: LC_ExportEmployeeHheeSummaryIn,
  ): Promise<ApiResponse<{ blob: Blob; filename: string }>> {
    const queryString = buildQueryString({
      monthlyCutId: input.monthlyCutId,
      format: input.format,
      companyId: input.companyId,
      employeeId: input.employeeId,
      type: input.type,
    });

    const endpoint = `${API_CONFIG.ENDPOINTS.MONTHLY_REPORT_HHEE_EXPORT}${queryString}`;

    return apiClient.downloadBlobWithFilename(
      endpoint,
      { method: 'GET' },
    );
  }
}

export const overtimeExportService = new OvertimeExportService();
